import { render, staticRenderFns } from "./AddComplaint.vue?vue&type=template&id=9fa5f002&scoped=true&"
import script from "./AddComplaint.vue?vue&type=script&lang=js&"
export * from "./AddComplaint.vue?vue&type=script&lang=js&"
import style0 from "./AddComplaint.vue?vue&type=style&index=0&id=9fa5f002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa5f002",
  null
  
)

export default component.exports